import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { GlobalStyle } from "@swegon/sds-core";
import { SdsSetup, SdsWrapper } from "./Sds";

import ApplicationRoutes from "./routes";
import Login from "./pages/Login";
import SignOut from "./pages/SignOut";
import SignedOn from "./pages/SignedOn";
import AuthorizationRoute from "./routes/AuthorizationRoute";

import NotFound from "./pages/NotFound";
import NoAccess from "./pages/NoAccess";

const basename = process.env.SDS_APP_PREFIX;

const App = () => (
    <SdsSetup>
        <Router basename={basename}>
            <div className='App'>
                <GlobalStyle />
                <SdsWrapper>
                    <Switch>
                        <Route path='/login' component={Login} />
                        <Route path='/signout' component={SignOut} />
                        <Route path='/noAcess' component={NoAccess} />
                        <Route path='/Forbidden' component={NoAccess} />
                        <AuthorizationRoute exact path='/' component={ApplicationRoutes} />
                        <Route path='/authorized' component={SignedOn} />
                        <Route path='*' component={NotFound} />
                    </Switch>
                </SdsWrapper>
            </div>
        </Router>
    </SdsSetup>
);
export default App;
